export const formDateConstants = {
    options: {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    },
    region: 'en-US'
};
